import { initializeClaimLink } from "~/utils/claim-link";
/**
 * By default, React Router will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `bun run --bun react-router reveal` ✨
 * For more information, see https://reactrouter.com/explanation/special-files#entryclienttsx
 */

import * as Sentry from "@sentry/react-router";
import { reactRouterTracingIntegration } from "@sentry/react-router";
import { HydratedRouter } from "react-router/dom";
import { startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { scrubSentryRequestCredentials } from "~/utils/sentry-privacy.mjs";

declare global {
  interface Window {
    ENV?: {
      SENTRY_DSN?: string;
      SENTRY_ENVIRONMENT?: string;
    };
  }
}

initializeClaimLink();

const environment = window.ENV?.SENTRY_ENVIRONMENT || "development";
const isEnabled = environment !== "development";

Sentry.init({
  dsn: window.ENV?.SENTRY_DSN,
  environment,
  enabled: isEnabled,
  sendDefaultPii: true,
  beforeSend: scrubSentryRequestCredentials,
  beforeSendTransaction: scrubSentryRequestCredentials,
  integrations: [reactRouterTracingIntegration()],
  tracesSampleRate: 0.1,
  tracePropagationTargets: [/^\//],
  ignoreErrors: [/No route matches URL/],
});

startTransition(() => {
  hydrateRoot(document, <HydratedRouter />);
});
